<template>
  <div class="not-found-component wrap-content">
    <div class="font-effect"><span>4</span><span>0</span><span>4</span></div>
  </div>
</template>

<script>
export default {
  name: 'notFoundComponent'
}
</script>

<style lang="less" scoped>
  .not-found-component {
    flex: 1;
    .font-effect {
      text-transform: uppercase;
      display: block;
      font-size: 160px;
      line-height: 160px;
      color: @color-blue;
      text-shadow: -6px 8px 8px rgba(@color-blue, .5);
      font-weight: bold;
      letter-spacing: 16px;
      text-align: center;
      margin-top: 15vh;
      span {
        display: inline-block;
        font-weight: bold;
        &:nth-child(2) {
          animation: shrinkjump 1s ease-out;
          transform-origin: bottom center;
        }
      }
    }
  }
  @keyframes shrinkjump {
    10%, 25% {
      transform: scale(2, .2) translate(0, 0);
    }
    40%, 55% {
      transform: scale(1) translate(0, -150px);
    }
    80% {
      transform: scale(1) translate(0, 0);
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/404/index.vue